import axios from 'axios'
import qs from 'qs'
import { Message  } from 'element-ui'

let temConfig = null ;
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'http://test.risingch.com' : 'http://video.risingch.com';
axios.defaults.withCredentials = true
//请求拦截
axios.interceptors.request.use(
    config => {
      if(config.method === "post" && config.headers['Content-Type'] != 'multipart/form-data' )  {
          config.data = qs.stringify(config.data,{arrayFormat: 'brackets'})
          console.log(config.data)
      }
      return config;
    }
)
//响应拦截
axios.interceptors.response.use(
    res => {
        if(parseInt(res.data.code) == 1){
            Message({
                message: res.data.msg,
                type: 'warning'
            });
        }
        res.data.code = parseInt(res.data.code)
        return res.data
    },
    error => {
        let errMsg = '网路错误'
        switch(error.response.status){
            case 400:
                errMsg = '网路错误';
                Message({
                    message: errMsg,
                    type:'warning'
                })
                break;
            case 401:
                errMsg = '未登陆';
                Message({
                    message: errMsg,
                    type:'warning'
                })
                break;
            case 403:
                errMsg = '拒绝访问';
                Message({
                    message: errMsg,
                    type:'warning'
                })
                break;
            case 404:
                errMsg = '请求地址未找到';
                Message({
                    message: errMsg,
                    type:'warning'
                })
                break;
            case 408:
                errMsg = '请求超时';
                Message({
                    message: errMsg,
                    type:'warning'
                })
                break;
            case 500:
                errMsg = '服务器内部错误';
                Message({
                    message: errMsg,
                    type:'warning'
                })
                break;
            case 501:
                errMsg = '服务未实现';
                Message({
                    message: errMsg,
                    type:'warning'
                })
                break
            case 502:
                errMsg = '网关错误';
                Message({
                    message: errMsg,
                    type:'warning'
                })
                break
            case 503:
                errMsg = '服务不可用';
                Message({
                    message: errMsg,
                    type:'warning'
                })
                break
            case 504:
                errMsg = '网关超时';
                Message({
                    message: errMsg,
                    type:'warning'
                })
                break
            case 505:
                errMsg = 'HTTP版本不受支持';
                Message({
                    message: errMsg,
                    type:'warning'
                })
                break 
            default:
                Message({
                    message: errMsg,
                    type:'warning'
                })
                break
        }
        return Promise.reject(error)
    }
)
export default axios;